var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_vm._v(" Copyright © 三農科技有限公司. "+_vm._s(_vm.thisYear)+". ")])])}
var staticRenderFns = []

export { render, staticRenderFns }